import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../core/login/services/login.service';

@Component({
	selector: 'app-reset-password',
	styleUrls: ['./reset-password.component.css'],
	templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
	public passkey: string;
	public userid: string;
	public password = '';
	public confirmPassword = '';
	public errorMessage: string;
	public passwordLength = 6;
	public invalidPassword = false;
	public invalidInput = false;
	public showForm = true;

	constructor(private route: ActivatedRoute, private loginService: LoginService, private router: Router) {}

	ngOnInit(): void {
		this.route.params.subscribe((params: any) => {
			this.passkey = params['passkey'];
			this.userid = params['userid'];
		});
	}

	validateUser(): void {
		this.errorMessage = '';
		if (this.password === '' || this.confirmPassword === '') {
			this.errorMessage = 'Please fill all the details.';
		} else {
			if (this.password.length < this.passwordLength) {
				this.errorMessage = `Password must have ${this.passwordLength} characters.`;
				this.invalidPassword = true;
			} else if (this.password !== this.confirmPassword) {
				this.errorMessage = 'New password and Confirm new password are not same.';
				this.invalidInput = true;
			} else {
				this.errorMessage = '';
				this.invalidInput = false;
				this.invalidPassword = false;
				const details = {
					passkey: this.passkey,
					password: this.password,
					userid: this.userid
				};
				this.loginService.changePassword(details).subscribe(
					(res: any) => {
						if (res.success) {
							this.showForm = false;
						} else {
							this.errorMessage = res.message;
						}
					},
					function (error: any): void {
						this.errorMessage = 'Something went wrong. Please try after some time.';
					}
				);
			}
		}
	}

	redirectToLogin(): void {
		this.router.navigate(['login']);
	}
}
